import React from 'react'
import { useTranslation } from 'next-i18next'
import { twJoin } from 'tailwind-merge'
import { PrimaryButtonWithCustomTheme } from 'modules/course/components/primary-button-with-custom-theme'
import { useGetCoursePageUrl } from 'modules/course/hooks/use-course-path-url'
import useStepRouter from 'modules/course/hooks/use-step-router'
import { CourseQuizId } from 'modules/course/types/course-quiz-interface'
import { CourseStepEnum } from 'modules/course/types/course-step-type'
import { addPublicCustomClassNamePrefix } from 'modules/course/utils/add-class-prefix'
import { CourseInfoScreenLayout } from './course-info-screen-layout'

interface CourseNeedCompleteModuleScreenProps {
  blockingStep?: CourseQuizId
}

export const CourseNeedCompleteModuleScreen = ({
  blockingStep,
}: React.PropsWithChildren<CourseNeedCompleteModuleScreenProps>) => {
  const { t } = useTranslation()

  const coursePath = useGetCoursePageUrl()

  const { findStepById, findStep, step: currentStep } = useStepRouter()

  let step = findStepById(blockingStep)

  if (!step?.available) {
    step = findStep()
  }

  const [message, cta] =
    currentStep?.type === CourseStepEnum.quiz
      ? [
          'course.quiz.complete_all_lectures_message',
          'course.quiz.go_to_uncompleted_lecture_button',
        ]
      : [
          'course.quiz.complete_previous_module_message',
          'course.quiz.go_to_uncompleted_module_button',
        ]

  return (
    <CourseInfoScreenLayout
      className={addPublicCustomClassNamePrefix(`course__info-screen--need-to-complete-module`)}
      text={t(message)}
      buttons={
        <PrimaryButtonWithCustomTheme
          className={twJoin(
            `font-bold`,
            addPublicCustomClassNamePrefix('course__button--go-to-uncompleted-module'),
          )}
          href={`/school/course/${coursePath}/${step?.type}/${step?.id}`}
        >
          {t(cta)}
        </PrimaryButtonWithCustomTheme>
      }
    />
  )
}
